import { TimeService } from '@abp/ng.core';

/**
 * "Now" as a `Date` whose local fields carry the tenant's wall clock, matching how the outgoing
 * `Date.prototype.toJSON` override reads local fields as tenant time. No zone = browser now.
 */
export function tenantNow(timeService: TimeService, zone: string | null | undefined): Date {
  return toTenantWallClock(timeService, zone, new Date());
}

/** An instant as a `Date` whose local fields carry the tenant's wall clock (see `tenantNow`). */
export function toTenantWallClock(timeService: TimeService, zone: string | null | undefined, instant: Date): Date {
  if (!zone) {
    return instant;
  }

  const tenant = timeService.toZone(instant, zone);
  return new Date(
    tenant.year,
    tenant.month - 1,
    tenant.day,
    tenant.hour,
    tenant.minute,
    tenant.second,
    tenant.millisecond,
  );
}
